import { Subject } from "rxjs";

export const ClickHistorySubject = new Subject<any>();
